module.exports = __webpack_public_path__ + "static/media/smartphoneHand.a1dd64c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/smartphoneHand.svg
// module id = 410
// module chunks = 0